// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { EventEmitter } from 'events';
import { Resources } from '@shared/localizations/Resources';
export class BaseGroupItem {
    constructor(type, controller, isOpened) {
        this._eventEmitter = new EventEmitter();
        this.type = type;
        this.controller = controller;
        this.isOpened = isOpened;
    }
    subscribeOnUpDateEmit(callback) {
        this._eventEmitter.on('update', callback);
    }
    unsubscribeOnUpDateEmit(callback) {
        this._eventEmitter.off('update', callback);
    }
    onUpDateEmit() {
        this._eventEmitter.emit('update');
    }
    subscribeChangeOpenedStateEmit(callback) {
        this._eventEmitter.on('changeOpenedState', callback);
    }
    unsubscribeChangeOpenedStateEmit(callback) {
        this._eventEmitter.off('changeOpenedState', callback);
    }
    onChangeOpenedStateEmit(itemId, isOpened) {
        this._eventEmitter.emit('changeOpenedState', itemId, isOpened);
    }
    getController() {
        return this.controller;
    }
    getType() {
        return this.type;
    }
    getOpenedState() {
        return this.isOpened;
    }
    getGroupName() {
        const groupLabelKey = this.getGroupNameKey();
        if (isNullOrUndefined(groupLabelKey)) {
            return 'add new group name';
        }
        return Resources.getResource(groupLabelKey);
    }
    getGroupNameKey() {
        return null;
    }
}
